import React, {useState, useEffect} from 'react';
import AddFileView from './AddFileView';
import api from '../../../../axios.config';
import Spinner from '../../../Spinner/Spinner';
import swal from 'sweetalert';
import {useLocation} from 'react-router-dom';
import {useNavigate} from 'react-router';
import {getPlaceNameHistory, getPlaceNameAll, getChantierIdInfo} from '../../../../services/MadricService';
import {MadricContext} from '../../../../Context/MadricContext';
import {useContext} from 'react';

/**
 *  L'accueil
 * @param {*} props props
 * @return {JSX}
 */
function AddFile(props) {
  const [isLoading, setIsLoading] = useState(false);

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    let day = today.getDate();

    month = month < 10 ? `0${month}` : month;
    day = day < 10 ? `0${day}` : day;

    return `${year}-${month}-${day}`;
  };

  const [form, setForm] = useState({
    file: null,
    note: '',
    chantier: [],
    nomFichier: '',
    selectedDate: getCurrentDate(),
    extra1: false,
    extra2: false,
    extra3: false,
    prive: false,
  });

  const location = useLocation();
  const navigate = useNavigate();

  const [errors, setErrors] = useState({});

  const {setWhatToShow, setProjectInfo, projectInfoObtained} = useContext(MadricContext);

  const [placeName, setPlaceName] = useState([]);
  const [checkedChantier, setCheckedChantier] = useState(false);

  let checkedChantierAfterRender = false;

  useEffect(() => {
    fetchPlaces();
    fetchPlaceId();
  }, []);

  const handleChantierCheckBox = () => {
    setCheckedChantier((prevState) => (!prevState));
    checkedChantierAfterRender = !checkedChantier;
    fetchPlaces();
  };


  /**
   * Va chercher la liste des chantiers
   */
  async function fetchPlaces() {
    if (checkedChantierAfterRender) {
      setIsLoading(true);
      const res = await getPlaceNameAll();
      setIsLoading(false);
      setPlaceName(res);
    } else {
      setIsLoading(true);
      const res = await getPlaceNameHistory();
      setIsLoading(false);
      setPlaceName(res);
    }
  }

  /**
   * Permet de recevoir le id de la place
   */
  async function fetchPlaceId() {
    const res = await getChantierIdInfo(location.state.id);
    setForm({
      ...form,
      chantier: [{label: res.name, value: res.id}],
    });
  }

  const openModal = () => {
    swal('Votre PDF a été enregistré');
  };


  const handleFileChange = (event) => {
    if (event.target.files !== null) {
      const file = event.target.files[0];
      if (form.nomFichier === '') {
        setForm({
          ...form,
          nomFichier: file.name,
          file: file,
        });
      } else {
        setForm({
          ...form,
          file: file,
        });
      }
    }
  };

  const handleChangeValue = (event) => {
    setForm({
      ...form,
      [event.target.name]: [event.target.value],
    });
  };

  const handleChantierChange = (chantierForm) => {
    setForm({
      ...form,
      chantier: chantierForm,
    });
  };

  const handleChangeCheckbox = (event) => {
    setForm({
      ...form,
      [event.target.name]: [event.target.checked],
    });
  };


  const handleSubmit = async (event) => {
    event.preventDefault();

    const errorsForm = {};
    setErrors(errorsForm);

    if (form.file === null) {
      errorsForm.file = 'Le média est obligatoire';
    }

    if (form.chantier === null || form.chantier.length === 0) {
      errorsForm.chantier = 'Le chantier est obligatoire';
    }

    if (Object.keys(errorsForm).length > 0) {
      setErrors(errorsForm);
    } else {
      const formData = new FormData();
      formData.append('file', form.file);
      formData.append('note', form.note);
      formData.append('name', form.nomFichier);
      formData.append('date', form.selectedDate);
      formData.append('extra1', form.extra1);
      formData.append('extra2', form.extra2);
      formData.append('extra3', form.extra3);
      formData.append('permission', form.prive);
      form.chantier.forEach((item, index) => {
        formData.append(`chantier[${index}]`, item.value);
      });

      setIsLoading(true);
      await api.post('/files', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((r) =>{
        if (projectInfoObtained.current.includes('file')) {
          let newfile = r.data.data.data;
          newfile.extra1 = r.data.extra1;
          newfile.extra2 = r.data.extra2;
          newfile.extra3 = r.data.extra3;

          setProjectInfo((previous) => [newfile, ...previous].sort((a, b) => {
            if (a.date < b.date) {
              return 1;
            }
            return -1;
          }));
        }

        openModal();
      }).finally(() => {
        setWhatToShow('5');
        navigate('/chantier/' + location.state.id);
        setIsLoading(false);
      });
    }
  };

  return (
    <React.Fragment>
      {isLoading && <Spinner />}
      <AddFileView
        handleSubmit={handleSubmit}
        handleFileChange={handleFileChange}
        handleChantierChange={handleChantierChange}
        handleChantierCheckBox={handleChantierCheckBox}
        placeName={placeName}
        checkedChantier={props.checkedChantier}
        handleChangeValue={handleChangeValue}
        handleChangeCheckbox={handleChangeCheckbox}
        form={form}
        setForm={setForm}
        errors={errors}


      />
    </React.Fragment>
  );
}

export default AddFile;
